/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import styled from 'styled-components';

import { colors } from '../../../../../theme';

const TableCellNoValueStyled = styled.div.attrs({
    className: 'table-cell__no-value',
})`
    color: ${colors.textColorOpacity};
`;

export default TableCellNoValueStyled;
